var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_327_1086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1429 23.1429H12V18.8571H23.1429V23.1429Z",
    fill: "#D7F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1429 23.1429H12V18.8571H23.1429V23.1429Z",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 23.1429H0.856934",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57129 18.8571H11.9999",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8954 9.10039H11.1426V4.29545H13.1964C18.6895 4.29545 23.1426 8.74848 23.1426 14.2416V18.8568L18.4166 18.8571V14.6216C18.4166 11.5723 15.9447 9.10039 12.8954 9.10039Z",
    fill: "#D7F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42822 4.28571H11.1425V12C11.1425 12.9493 10.3776 13.7213 9.42829 13.73L5.21315 13.7686C4.23003 13.7776 3.42822 12.9832 3.42822 12V4.28571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42822 4.28571H11.1425V12C11.1425 12.9493 10.3776 13.7213 9.42829 13.73L5.21315 13.7686C4.23003 13.7776 3.42822 12.9832 3.42822 12V4.28571Z",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8954 9.10039H11.1426V4.29545H13.1964C18.6895 4.29545 23.1426 8.74848 23.1426 14.2416V18.8568L18.4166 18.8571V14.6216C18.4166 11.5723 15.9447 9.10039 12.8954 9.10039Z",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99986 0.857143H5.57129V4.28571H8.99986V0.857143Z",
    fill: "#D7F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57129 4.28571V0.857143H8.99986V4.28571",
    stroke: "#00A988",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_327_1086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.5b891ca6978d61832636333544a461e0.svg";
export { ForwardRef as ReactComponent };